import StoreHomePage from "./pages/StoreHomePage";
import StoreSalesPage from "./pages/StoreSalesPage";
import StoreItemsPage from "./pages/StoreItemsPage";
import StoreItemDetailPage from "./pages/StoreItemDetailPage";
import StoreMovementsPage from "./pages/StoreMovementsPage";
import StoreReportsPage from "./pages/StoreReportsPage";
import StoreRequestsPage from "./pages/StoreRequestsPage";
import StoreStaffPage from "./pages/StoreStaffPage";
import StoresPage from "./pages/StoresPage";

/**
 * The store is worked as a place, so it has its own shell and its own nav
 * (StoreShell) rather than nine entries in the portal's sidebar.
 *
 * Every screen sits on `store.access`; maintaining the item register
 * (`store.manage`) and moving stock (`store.movement`) are separate grants
 * checked at the buttons, since a route guard cannot express "may open this
 * page but not press that". super_admin bypasses all of it in
 * RequirePermission, so no entry names it.
 *
 * There is no Orders section: the Institute's store sells across the counter
 * and issues to staff, and does not take orders to fulfil later.
 */
export const storesRoutes = [
  { path: "/stores", element: <StoreHomePage />, perms: ["store.access"] },
  { path: "/stores/sales", element: <StoreSalesPage />, perms: ["store.access"] },
  { path: "/stores/items", element: <StoreItemsPage />, perms: ["store.access"] },
  // One item: where it sits, who holds it, and everything that has happened
  // to it. Reached by clicking the item on a store's shelf.
  { path: "/stores/items/:id", element: <StoreItemDetailPage />, perms: ["store.access"] },
  // Inventory is the stores and their shelves; Settings is the same screen's
  // maintenance side, so both resolve to it rather than duplicating the list.
  { path: "/stores/inventory", element: <StoresPage />, perms: ["store.access"] },
  { path: "/stores/settings", element: <StoresPage />, perms: ["store.access"] },
  { path: "/stores/requests", element: <StoreRequestsPage />, perms: ["store.access"] },
  { path: "/stores/reports", element: <StoreReportsPage />, perms: ["store.access"] },
  { path: "/stores/staff", element: <StoreStaffPage />, perms: ["store.access"] },
  { path: "/stores/movements", element: <StoreMovementsPage />, perms: ["store.access"] },
];
